import type { WeeklyPreference } from '@/types/pops'

export class PackageRedemption {
  id?: number
  pack_order_id?: number
  week?: string
  status?: string
  weekly_preference?: WeeklyPreference

  constructor(rawPackgeRedemption: any) {
    this.id = rawPackgeRedemption.id
    this.pack_order_id = rawPackgeRedemption.pack_order_id
    this.week = rawPackgeRedemption.week
    this.status = rawPackgeRedemption.status
    this.weekly_preference = rawPackgeRedemption.weekly_preference
  }

  get isActive() {
    return this.status === 'active'
  }

  get shippingAddress() {
    return this.weekly_preference?.shipping_address
  }

  get redemptionStatus() {
    switch (this.status) {
      case 'new':
        return 'Pending'
      case 'pending':
        return 'Scheduled'
      case 'completed':
      case 'processed':
        return 'Redeemed'
      default:
        return 'Error'
    }
  }

  get redemptionStatusColor() {
    switch (this.status) {
      case 'new':
        return 'tangerine-new'
      case 'pending':
        return 'melon'
      case 'completed':
      case 'processed':
        return 'black'
      default:
        return 'tomato'
    }
  }
}
